import api from '~/api';
import { PartnerStatusResponse, SwitchResponse } from '../dtos/partnerResponse';
import Partner, { PartnerStatus } from '../models/partner.model';
import User from '../models/user.model';

export const PartnerStatusMap: Record<PartnerStatusResponse, PartnerStatus> = {
  draft: PartnerStatus.Draft,
  invited: PartnerStatus.Invited,
  onboarding: PartnerStatus.Onboarding,
  active: PartnerStatus.Active,
  lost: PartnerStatus.Lost,
  inactive: PartnerStatus.Inactive,
};

export const switchUserRequest = async (
  partnerId: string
): Promise<{ user: User; partner: Partner }> => {
  const {
    data: { partner, user_id },
  } = await api.post<SwitchResponse>(`/v1/partner/${partnerId}/switch`);

  const userProfilePhoto = null;
  return {
    user: new User(
      user_id,
      partner.partner_user_first_name,
      partner.partner_user_last_name,
      userProfilePhoto
    ),
    partner: new Partner(
      partner.partner_id,
      partner.partner_name,
      PartnerStatusMap[partner.partner_status]
    ),
  };
};
